"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'EditorialCards_1_0_0',
  editorialLayout: 'contentgrid',
  columns: [{
    image: {
      image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/electric-charging.jpg',
      altText: 'Electirc and Power'
    },
    description: {
      sectionHeading: 'Electirc and Power #1#',
      mainHeading: 'Charging your Outlander PHEV #2#',
      paragraph: 'From charging points to connector types, this video gives you all the information you #2# need on charging your PHEV. '
    },
    link: {
      url: '#',
      label: 'Click Here',
      priority: 'low'
    }
  }, {
    image: {
      image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/bonnet.jpg',
      altText: 'Under the Bonnet'
    },
    description: {
      sectionHeading: 'Under the Bonnet',
      mainHeading: 'Learn under the bonnet basics',
      paragraph: 'The most important (and luckily one of the easiest) ways to look after your car is by checking fluid levels.'
    }
  }, {
    image: {
      image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/lifestyle.jpg',
      altText: 'Lifestyle'
    },
    description: {
      sectionHeading: 'Lifestyle #1#',
      mainHeading: 'Getting the most from your PHEV',
      paragraph: 'Keep your battery power going longer, learn about regenerative braking, ECO mode and more in this video.'
    }
  }]
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;